export default "__VITE_ASSET__3bf444da__"